import { EdsFilterType } from '@/features/eds/enums/EdsFilterType';

export const edsFilterArrayTypes = [
  EdsFilterType.Select,
  EdsFilterType.MultiSelect,
  EdsFilterType.MultiCheckbox,
  EdsFilterType.Assignee,
];

export const edsFilterDateRangeTypes = [EdsFilterType.DateRange];

export const edsFilterRangeTypes = [EdsFilterType.InputNumberRange, ...edsFilterDateRangeTypes];

export const edsFilterBooleanTypes = [EdsFilterType.Checkbox];
